(function () {
  if (window.__atcToastBound) return;
  window.__atcToastBound = true;

  var toast = document.getElementById('atc-confirmation-toast');
  if (!toast) return;

  var detailEl = toast.querySelector('[data-atc-toast-detail]');
  var hideTimer;
  var lastToastAt = 0;
  var lastToastDetail = '';

  function productTitleFromData(data) {
    if (!data || data.status) return '';
    if (data.product_title) return data.product_title;
    if (data.title) return data.title;
    if (data.items && data.items.length) {
      var item = data.items[0];
      return item.product_title || item.title || '';
    }
    return '';
  }

  function productTitleFromDom() {
    var el = document.querySelector(
      '.product__title, .product__title h1, .product-title, [data-product-title]'
    );
    return el ? el.textContent.trim() : '';
  }

  function showAtcToast(detail) {
    var text = detail || '';
    var now = Date.now();
    if (now - lastToastAt < 450 && text === lastToastDetail) return;
    lastToastAt = now;
    lastToastDetail = text;

    if (detailEl) detailEl.textContent = text;
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.hidden = true;
      }, 280);
    }, 3200);
  }

  window.showAtcToast = showAtcToast;

  function handleCartAdd(payload) {
    var data = payload && payload.cartData ? payload.cartData : payload;
    var detail = productTitleFromData(data) || productTitleFromDom();
    showAtcToast(detail);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.cartData?.status) return;
      if (
        event.source === 'product-form' ||
        event.source === 'product-form-component' ||
        event.source === 'quick-add' ||
        !event.source
      ) {
        handleCartAdd(event);
      }
    });
  }

  document.addEventListener('cart:update', function (event) {
    if (event.detail?.cartData?.status) return;
    handleCartAdd(event.detail || event);
  });

  var originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(function (response) {
      try {
        var input = arguments[0];
        var url = String(typeof input === 'string' ? input : input && input.url);
        if (url.indexOf('/cart/add') !== -1 && response.ok) {
          response
            .clone()
            .json()
            .then(function (data) {
              if (data && !data.status) handleCartAdd(data);
            })
            .catch(function () {});
        }
      } catch (e) {}
      return response;
    });
  };
})();
